import PATHS from "utils/paths";
import { PRODUCT_TITLE } from "constants/marketing";

export const TITLE = "title";
export const DESCRIPTION = "description";
export const NAME = "name";
export const IMAGE = "image";
export const OG_IMAGE = "og:image";
export const OG_TITLE = "og:title";
export const OG_URL = "og:url";
export const OG_DESCRIPTION = "og:description";
export const OG_TYPE = "og:type";
export const OG_IMAGE_WIDTH = "og:image:width";
export const OG_IMAGE_HEIGHT = "og:image:height";
export const OG_SITE_NAME = "og:site_name";
export const TWITTER_SITE = "twitter:site";
export const TWITTER_CREATOR = "twitter:creator";
export const TWITTER_CARD = "twitter:card";
export const TWITTER_TITLE = "twitter:title";
export const TWITTER_DESCRIPTION = "twitter:description";
export const TWITTER_IMAGE = "twitter:image";
export const ICON = "icon";
export const ICON_SIZES = "icon:sizes";
export const APPLE_TOUCH_ICON = "apple-touch-icon";
export const MASK_ICON = "mask-icon";
export const MASK_ICON_COLOR = "mask-icon:color";

export const DEFAULT_TWITTER_CARD = "summary_large_image";
export const DEFAULT_ICON_SIZES = "192x192";
export const DEFAULT_MASK_ICON_COLOR = "#FFFFFF";
export const DEFAULT_OG_TYPE = "website";
export const DEFAULT_OG_IMAGE_WIDTH = "1200";
export const DEFAULT_OG_IMAGE_HEIGHT = "630";

export const METADATA_KEYS = [
  TITLE,
  DESCRIPTION,
  NAME,
  IMAGE,
  OG_IMAGE,
  OG_TITLE,
  OG_URL,
  OG_DESCRIPTION,
  OG_TYPE,
  OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT,
  OG_SITE_NAME,
  TWITTER_SITE,
  TWITTER_CREATOR,
  TWITTER_CARD,
  TWITTER_TITLE,
  TWITTER_DESCRIPTION,
  TWITTER_IMAGE,
  ICON,
  ICON_SIZES,
  APPLE_TOUCH_ICON,
  MASK_ICON,
  MASK_ICON_COLOR
];

const APP_ROOT = `https://priceblocs.com`;

const HANDLE = "@priceblocs";
const BRAND = "PriceBlocs";
const BASE = {
  [OG_TYPE]: "website",
  [OG_IMAGE_WIDTH]: "1200",
  [OG_IMAGE_HEIGHT]: "630",
  [TWITTER_SITE]: HANDLE,
  [TWITTER_CREATOR]: HANDLE,
  [TWITTER_CARD]: "summary_large_image",
  [OG_SITE_NAME]: BRAND,
  [TWITTER_TITLE]: BRAND,
  [TITLE]: PRODUCT_TITLE,
  [NAME]: PRODUCT_TITLE,
  [OG_TITLE]: PRODUCT_TITLE,
  [ICON]: "/touch-icon.png",
  [ICON_SIZES]: "192x192",
  [APPLE_TOUCH_ICON]: "/touch-icon.png",
  [MASK_ICON]: "/favicon-mask.svg",
  [MASK_ICON_COLOR]: "#FFFFFF"
};

const getOgURL = (path) => {
  return path
    ? path === PATHS.HOME
      ? `${APP_ROOT}${path}`
      : `${APP_ROOT}${path}/`
    : `${APP_ROOT}/`;
};

const getDefaultMeta = (path) => {
  const ogURL = getOgURL(path);

  return {
    ...BASE,
    [OG_URL]: ogURL,
    [DESCRIPTION]: DESCRIPTIONS[PATHS.HOME],
    [OG_DESCRIPTION]: DESCRIPTIONS[PATHS.HOME],
    [TWITTER_DESCRIPTION]: DESCRIPTIONS[PATHS.HOME],
    [IMAGE]: OG_IMAGES[PATHS.HOME],
    [OG_IMAGE]: OG_IMAGES[PATHS.HOME],
    [TWITTER_IMAGE]: TWITTER_IMAGES[PATHS.HOME]
  };
};

const TITLES = {
  [PATHS.HOME]: "PriceBlocs - sell anywhere with one click payment links.",
  [PATHS.PRICING]: "PriceBlocs - choose the right plan for your team.",
  [PATHS.LINKS_SHOW]: "PriceBlocs - sell anywhere with one click payment links."
};

const NAMES = {
  [PATHS.HOME]: "PriceBlocs - sell anywhere with one click payment links.",
  [PATHS.PRICING]: "PriceBlocs - choose the right plan for your team.",
  [PATHS.LINKS_SHOW]: "PriceBlocs - sell anywhere with one click payment links"
};

const DESCRIPTIONS = {
  [PATHS.HOME]: "PriceBlocs - sell anywhere with one click payment links.",
  [PATHS.PRICING]: "PriceBlocs - choose the right plan for your team.",
  [PATHS.LINKS_SHOW]: "PriceBlocs - sell anywhere with one click payment links"
};

const OG_IMAGES = {
  [PATHS.HOME]: "https://priceblocs.com/meta/og-image-primary.jpg",
  [PATHS.PRICING]: "https://priceblocs.com/meta/og-image-pricing.jpg",
  [PATHS.LINKS_SHOW]: "https://priceblocs.com/meta/og-image-primary.jpg"
};

const TWITTER_IMAGES = {
  [PATHS.HOME]: "https://priceblocs.com/meta/twitter-card-primary.jpg",
  [PATHS.PRICING]: "https://priceblocs.com/meta/twitter-card-pricing.jpg",
  [PATHS.LINKS_SHOW]: "https://priceblocs.com/meta/twitter-card-primary.jpg"
};

const META_PROPS = [
  PATHS.HOME,
  PATHS.PRICING,
  PATHS.LINKS_SHOW,
  PATHS.LEVELS_EXPLAINED,
  PATHS.GOALS_EXPLAINED,
  PATHS.PRODUCTS_EXPLAINED,
  PATHS.TEAM_EXPLAINED,
  PATHS.EVALUATIONS_EXPLAINED
].reduce((memo, path) => {
  const ogURL = getOgURL(path);
  memo[path] = {
    ...BASE,
    // Title
    [TITLE]: TITLES[path],
    [NAME]: NAMES[path],
    [OG_TITLE]: TITLES[path],
    [OG_URL]: ogURL,
    // Description
    [DESCRIPTION]: DESCRIPTIONS[path],
    [OG_DESCRIPTION]: DESCRIPTIONS[path],
    [TWITTER_DESCRIPTION]: DESCRIPTIONS[path],
    [IMAGE]: OG_IMAGES[path],
    [OG_IMAGE]: OG_IMAGES[path],
    [TWITTER_IMAGE]: TWITTER_IMAGES[path]
  };
  return memo;
}, {});

export const getPageMetaProps = ({ path, metadata } = {}) => {
  const result =
    path && META_PROPS[path] ? META_PROPS[path] : getDefaultMeta(path);

  return { ...result, ...metadata };
};
